import { Button, Colors } from "@blueprintjs/core";
import { useMediaQuery } from "react-responsive";

import { isXsQuery } from "@/components/layout/Media";
import { RubricDetailQuery } from "@/graphql";

type Rubric = NonNullable<RubricDetailQuery["rubric"]>;

interface RubricCardProps {
  rubric: Rubric;
  onPreview: (rubric: Rubric) => void;
}

export function RubricCard({ rubric, onPreview }: RubricCardProps) {
  const isXs = useMediaQuery(isXsQuery);

  return (
    <div
      className={`bas round-corners mr-3 flex items-center justify-between gap-8 p-6 ${
        isXs ? "flex-col" : "flex-row"
      }`}
    >
      <div className="flex flex-col gap-2">
        <div className="text-lg font-semibold">{rubric.name}</div>
        <div className="text-sm text-gray-500">
          {rubric.evaluationCriteria?.length} criteria •{" "}
          {rubric.isGlobal ? "Core" : "Workspace"}
        </div>
      </div>
      <div className="flex min-w-[130px] justify-stretch">
        <Button
          text="Preview"
          style={{
            backgroundColor: Colors.LIGHT_GRAY5,
            color: Colors.DARK_GRAY1,
            width: "100%",
          }}
          onClick={() => onPreview(rubric)}
        />
      </div>
    </div>
  );
}
